<style src="./MetaContents.scss" lang="scss" scoped></style>
<script src="./MetaContents.js"></script>

<template>
	<section class="meta-contents-contain">
		<VirtualMarketplaceComponent />
		<MetaSlideComponent
			v-if="metaContentSlides"
			:meta-name="metaContentName"
			:meta-slides="metaContentSlides"
		/>
	</section>
</template>